import { render } from "./OccupationalSafetyExpertsBPage.vue?vue&type=template&id=196da864&scoped=true"
import script from "./OccupationalSafetyExpertsBPage.vue?vue&type=script&lang=js"
export * from "./OccupationalSafetyExpertsBPage.vue?vue&type=script&lang=js"

import "./OccupationalSafetyExpertsBPage.vue?vue&type=style&index=0&id=196da864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196da864"]])

export default __exports__